import { render, staticRenderFns } from "./PhotoTrap.vue?vue&type=template&id=6d32912e&"
import script from "./PhotoTrap.vue?vue&type=script&lang=js&"
export * from "./PhotoTrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports